import useScreenSize from '../../hooks/useScreenSize'
import MediumScreenFooter from './MediumScreenFooter/MediumScreenFooter'
import SmallScreenFooter from './SmallScreenFooter/SmallScreenFooter'

export default function FooterSection() {
  const isMediumScreen = useScreenSize('md')

  return isMediumScreen ? <MediumScreenFooter /> : <SmallScreenFooter />
}
